<qrcode
  #qrCode
  [qrdata]="qrData"
  [width]="width"
  [imageSrc]="qrImageSrc"
  [elementType]="elementType"
  [errorCorrectionLevel]="'H'"
  cssClass="tw-flex tw-justify-center"
></qrcode>
